import Vue from 'vue'
import Router from 'vue-router'
import MapComponent from './components/map/map.component'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    
    {
      path: '/therm/:uid',
      name: 'therm',
      component: MapComponent,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/terra/:uid',
      name: 'terra',
      component: MapComponent,
      meta: {
        requiresAuth: true
      }
    },
  ]
})

export default router;
